// AddressesModal.jsx
import "./AddressesModal.scss";

function AddressesModal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null; // only render when open

  return (
    <div className="am-modal-container" /* onClick={onClose}*/>
      <div className="am-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{title}</h2>
        <button className="am-modal-close" onClick={onClose}>
          ×
        </button>
        {children}
      </div>
    </div>
  );
}

export default AddressesModal;
